import React from "react";

import Courses from "../components/Courses";

const AllCourses = () => {
  return (
    <div>
      
      <Courses />
      
    </div>
  );
};

export default AllCourses;
